// extracted by mini-css-extract-plugin
module.exports = {"noCard":"style_noCard__JX0TE","itemsList":"style_itemsList__3TllV"};